import { z } from "zod";

export const statusSchema = z.object({
  page: z.object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    time_zone: z.string(),
    updated_at: z.string(),
  }),
  status: z.object({
    indicator: z.string(),
    description: z.string(),
  }),
});

export type Status = z.infer<typeof statusSchema>;
